import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from "./App";
import Login from "./pages/login";
import Register from "./pages/register";
import ForgetPassword from "./pages/forget-password";
import ResetPassword from "./pages/reset-password";
import DashboardLayout from "./layout/dashboard";
import Dashboard from "./pages/thm/dashboard";
import Portin from "./pages/support/portin";
import AutoRenew from "./pages/support/auto-renew";
import AutoTopup from "./pages/support/auto-topup";
import AddBundle from "./pages/support/add-bundle";
import EmailStatus from "./pages/support/email-status";
import DetachNumber from "./pages/support/detach-number";
import THCC from "./pages/thcc";
import THM from "./pages/thm";
import THA from "./pages/tha";
import SendCredit from "./pages/sendcredit";
import FusionHub from "./pages/fusionhub";
import PageNotFound from "./pages/pagenotfound";
import THMReports from "./pages/thm/prepaid-sim-report";
import EmptyLayout from "./layout/empty-layout";
import Now from "./pages/now";
import SimReplacement from "./pages/support/sim-replacement";
import PaidCampaigns from "./pages/thm/paidCampaigns";
import PortInReports from "./pages/thm/portin-report";
import PortOutReports from "./pages/thm/portout-report";
import Sales from "./pages/thm/sales";
import PlanSubscriptionReport from "./pages/thm/subscription-report";
import ActivityReport from "./pages/tha/activity-report";
import ThaPaymentStats from "./pages/tha/payment-stats";
import NowPaymentStats from "./pages/now/payment-stats";
import ThccPaymentStats from "./pages/thcc/payment-stats";
import ThmPaymentStats from "./pages/thm/payment-stats";
import CreateBundles from "./pages/thm/create-bundles";
import SimRequest from "./pages/support/sim-request";
import CancelFulfillment from "./pages/support/cancel-fulfillment";
import PortoutCustomerStatus from "./pages/thm/portoutCustomerStatus";
import DeleteRequest from "./pages/tha/delete-request";
import OperatorCms from "./pages/sendcredit/operator-cms";
import DownloadInvoice from "./pages/support/download-invoice";
import DailySummary from "./pages/sendcredit/daily-summary";
import CustomerDetails from "./pages/sendcredit/customer-details";
import TransactionDetails from "./pages/sendcredit/transaction-details";
import VendorConfiguration from "./pages/tha/vendor-configuration";
import InternationalTopup from "./pages/tha/international-topup";
import CustomerStatus from "./pages/thm/customerStatus";
import TopProducts from "./pages/sendcredit/top-products";
import CreditSimStatus from "./pages/support/creditsim-status";
import RetryMethod from "./pages/support/retry-method";
import ThaOperatorCms from "./pages/tha/operator-cms";
import OtpVerification from "./pages/support/otp-verification";
import TransactionStatus from "./pages/fusionhub/transaction-status";
import ProductList from "./pages/fusionhub/product-list";
import SyncProduct from "./pages/fusionhub/sync-product";
import UserDetails from "./pages/fusionhub/user-details";
import CheckBalance from "./pages/sendcredit/check-balance";
import OnlineNumberUpdate from "./pages/support/online-number-update";
import ViewMsisdn from "./pages/support/view-msisdn";
import PaypalCancellation from "./pages/support/paypal-cancellation";
import MsisdnStatus from "./pages/support/msisdn-status";
import BulkUpdate from "./pages/support/bulk-update";
import EtcUsers from "./pages/support/etc-users";
import SimDispatch from "./pages/support/sim-dispatch";
import PortOutsDashboard from "./pages/thm/portouts-dashboard";
import OperatorName from "./pages/fusionhub/operator-name";
import FreeSimStatus from "./pages/support/freesim-status";
import RevenueReport from "./pages/thm/reports/revenue-report";
import PlanCohortAnalysis from "./pages/thm/reports/plan-cohort-analysis";
import FaqManagement from "./pages/thm/faq-management";
import THATransactionDetails from "./pages/tha/transaction-details";
import GetIMEI from "./pages/support/imei-details";
import GetTHATraxSearch from "./pages/support/trax-search-tha";
import GetPaypalTraxSearch from "./pages/support/trax-search-paypal";
import GetTHCCTraxSearch from "./pages/support/trax-search-thcc";
import GetNowtelCardTraxSearch from "./pages/support/trax-search-nowtel-card";
import UsageHistory from "./pages/support/usage-history";
import AuditTrail from "./pages/support/audit-trail";
import BundleStatus from "./pages/support/bundle-status";
import ThaCohortReport from "./pages/tha/tha-cohort-report";
import CallingCardsDetail from "./pages/support/calling-cards-detail";
import AddCampaigns from "./pages/promocode/add-campaign";
import PromoCode from "./pages/promocode";
import AddPromoCode from "./pages/promocode/add-promocode";
import WelcomeOfferTopUp from "./pages/tha/welcome-offer";
import CallingReports from "./pages/tha/calling-report";
import CustomerdetailThaThcc from "./pages/support/customerdetail-tha-thcc";
import IVR from "./pages/ivr";
import IVRLogs from "./pages/ivr/ivr-logs";
import PopularProducts from "./pages/tha/add-popular-product";
import CDRHistory from "./pages/support/thcc-thrcc-cdr";
import SentimentCategories from "./pages/thm/sentiment-categories";
import DtOneTransactions from "./pages/support/dtone-transactions";
import ReloadlyTransactions from "./pages/support/reloadly-transactions";

const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        {/* Routes that use layout 1 */}
        <Route element={<EmptyLayout />}>
          <Route index element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        {/* Routes that use layout 2 */}
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<Portin />} />
          <Route path="/support/portin" element={<Portin />} />
          <Route path="/support/auto-renew" element={<AutoRenew />} />
          <Route path="/support/auto-topup" element={<AutoTopup />} />
          <Route path="/support/sim-replacement" element={<SimReplacement />} />
          <Route
            path="/support/online-number-update"
            element={<OnlineNumberUpdate />}
          />
          <Route path="/support/bulk-update" element={<BulkUpdate />} />
          <Route path="/support/add-bundle" element={<AddBundle />} />
          <Route path="/support/email-status" element={<EmailStatus />} />
          <Route path="/support/detach-number" element={<DetachNumber />} />
          <Route path="/support/sim-request" element={<SimRequest />} />
          <Route
            path="/support/customerdetail-tha-thcc"
            element={<CustomerdetailThaThcc />}
          />
          <Route
            path="/support/cancel-fulfillment"
            element={<CancelFulfillment />}
          />
          <Route
            path="/support/creditsim-status"
            element={<CreditSimStatus />}
          />
          <Route path="/support/freesim-status" element={<FreeSimStatus />} />
          <Route path="/support/retry-method" element={<RetryMethod />} />
          <Route
            path="/support/otp-verification"
            element={<OtpVerification />}
          />
          <Route
            path="/support/download-invoice"
            element={<DownloadInvoice />}
          />
          <Route path="/support/view-msisdn" element={<ViewMsisdn />} />
          <Route
            path="/support/paypal-cancellation"
            element={<PaypalCancellation />}
          />
          <Route path="/support/msisdn-status" element={<MsisdnStatus />} />
          <Route path="/support/etc-users" element={<EtcUsers />} />
          <Route path="/support/sim-dispatch" element={<SimDispatch />} />
          <Route path="/support/imei-details" element={<GetIMEI />} />
          <Route path="/support/usage-history" element={<UsageHistory />} />
          <Route path="/support/audit-trail" element={<AuditTrail />} />
          <Route
            path="/support/dtone-transactions"
            element={<DtOneTransactions />}
          />
          <Route
            path="/support/reloadly-transactions"
            element={<ReloadlyTransactions />}
          />
          <Route
            path="/support/trax-search-tha"
            element={<GetTHATraxSearch />}
          />
          <Route
            path="/support/trax-search-paypal"
            element={<GetPaypalTraxSearch />}
          />
          <Route
            path="/support/trax-search-thcc"
            element={<GetTHCCTraxSearch />}
          />
          <Route
            path="/support/trax-search-nowtel-card"
            element={<GetNowtelCardTraxSearch />}
          />
          <Route path="/support/bundle-status" element={<BundleStatus />} />
          <Route path="/support/thcc-thrcc-cdr" element={<CDRHistory />} />
          <Route
            path="/support/calling-cards-detail"
            element={<CallingCardsDetail />}
          />
          <Route path="/thm/dashboard" element={<THM />} />
          <Route path="/thm/paidcampaigns" element={<PaidCampaigns />} />
          <Route path="/thm/prepaid-sim-report" element={<THMReports />} />
          <Route path="/thm/portin-report" element={<PortInReports />} />
          <Route path="/thm/portout-report" element={<PortOutReports />} />
          <Route path="/thm/sales" element={<Sales />} />
          <Route
            path="/thm/subscription-report"
            element={<PlanSubscriptionReport />}
          />
          <Route path="/thm/payment-stats" element={<ThmPaymentStats />} />
          <Route path="/thm/create-bundles" element={<CreateBundles />} />
          <Route
            path="/thm/portoutCustomerStatus"
            element={<PortoutCustomerStatus />}
          />
          <Route
            path="/thm/portouts-dashboard"
            element={<PortOutsDashboard />}
          />
          <Route path="/thm/customerStatus" element={<CustomerStatus />} />
          <Route path="/thm/faq-management" element={<FaqManagement />} />
          <Route
            path="/thm/reports/revenue-report"
            element={<RevenueReport />}
          />
          <Route
            path="/thm/reports/plan-cohort-analysis"
            element={<PlanCohortAnalysis />}
          />
          <Route
            path="/thm/sentiment-categories"
            element={<SentimentCategories />}
          />
          <Route path="/now" element={<Now />} />
          <Route path="/now/payment-stats" element={<NowPaymentStats />} />
          <Route path="/thcc" element={<THCC />} />
          <Route path="/thcc/payment-stats" element={<ThccPaymentStats />} />
          <Route path="/tha" element={<THA />} />
          <Route path="/tha/activity-report" element={<ActivityReport />} />
          <Route path="/tha/payment-stats" element={<ThaPaymentStats />} />
          <Route path="/tha/calling-report" element={<CallingReports />} />
          <Route path="/tha/delete-request" element={<DeleteRequest />} />
          <Route
            path="/tha/vendor-configuration"
            element={<VendorConfiguration />}
          />
          <Route
            path="/tha/international-topup"
            element={<InternationalTopup />}
          />
          <Route path="/tha/operator-cms" element={<ThaOperatorCms />} />
          <Route
            path="/tha/transaction-details"
            element={<THATransactionDetails />}
          />
          <Route path="/tha/tha-cohort-report" element={<ThaCohortReport />} />
          <Route path="/tha/welcome-offer" element={<WelcomeOfferTopUp />} />
          <Route path="/tha/popularity-rank" element={<PopularProducts />} />
          <Route
            path="/tha/add-popular-product"
            element={<PopularProducts />}
          />
          <Route path="/sendcredit" element={<SendCredit />} />
          <Route path="/sendcredit/operator-cms" element={<OperatorCms />} />
          <Route path="/sendcredit/daily-summary" element={<DailySummary />} />
          <Route path="/sendcredit/top-products" element={<TopProducts />} />
          <Route
            path="/sendcredit/customer-details"
            element={<CustomerDetails />}
          />
          <Route
            path="/sendcredit/transaction-details"
            element={<TransactionDetails />}
          />
          <Route path="/sendcredit/check-balance" element={<CheckBalance />} />
          <Route path="/fusionhub" element={<FusionHub />} />
          <Route
            path="/fusionhub/transaction-status"
            element={<TransactionStatus />}
          />
          <Route path="/fusionhub/product-list" element={<ProductList />} />
          <Route path="/fusionhub/sync-product" element={<SyncProduct />} />
          <Route path="/fusionhub/user-details" element={<UserDetails />} />
          <Route path="/fusionhub/operator-name" element={<OperatorName />} />

          <Route path="/promocode" element={<PromoCode />} />
          <Route path="/promocode/add-campaign" element={<AddCampaigns />} />
          <Route path="/promocode/add-promocode" element={<AddPromoCode />} />

          <Route path="/ivr" element={<IVR />} />
          <Route path="/ivr/ivr-logs" element={<IVRLogs />} />
        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>,
);
